import React, { useState, useEffect, useContext } from "react";
import ReactEcharts from "echarts-for-react";
import { SizeContext } from "layouts/AppMain";

type DataType = {
  name: string;
  value: number;
};

interface RosePieProps {
  data: DataType[];
  ring?: boolean;
  roseType?: boolean | "radius" | "area";
  hasOther?: boolean;
  color?: string[];
}

function getTop(data: DataType[] = [], hasOther = true) {
  const top5 = data
    .filter(({ name }) => !/其他|其它|other|N\/A/.test(name))
    .sort((a, b) => b.value - a.value)
    .slice(0, hasOther ? 7 : 8);

  const other = data
    .filter(({ name }) => !top5.find((t) => t.name === name))
    .reduce((a, b) => a + b.value, 0);

  return top5
    .concat(
      hasOther && other !== 0
        ? [
            {
              name: "其他",
              value: other,
            },
          ]
        : []
    )
    .sort((a, b) => b.value - a.value);
}

const Colors = [
  "#7ff4f6",
  "#58baec",
  "#408bdd",
  "#275fd0",
  "#0b2fc2",
  "#c03d9f",
  "#c48bdf",
  "#f1e9f8",
];

const getOption = (
  data: DataType[] = [],
  roseType: boolean | "radius" | "area",
  ring: boolean,
  color: string[] = Colors,
  s: (n: number, b?: boolean) => number
) => {
  const option = {
    color,
    tooltip: {},
    series: [
      {
        type: "pie",
        minAngle: 3.6,
        minShowLabelAngle: 10.8,
        radius: [ring ? "52%" : 0, "74%"],
        roseType,
        // startAngle: 135,
        label: {
          alignTo: "labelLine",
          formatter: "{val|{d}%}\n{name|{b}}",
          rich: {
            val: {
              color: "#fff",
              fontSize: s(24),
              fontFamily: "DIN",
            },
            name: {
              color: "#b7cfee",
              fontSize: s(16),
              fontFamily: "FZLanTingHei",
            },
          },
        },
        labelLine: {
          length: s(10),
          length2: s(10),
          lineStyle: {
            color: "rgb(78, 164, 212)",
          },
        },
        data: data
          .sort((a, b) => b.value - a.value)
          .map((d, i) => ({
            ...d,
            itemStyle: {
              color: color[i % data.length],
            },
          })),
      },
    ],
  };

  return option;
};

const RosePie: React.FC<RosePieProps> = ({
  data,
  roseType = false,
  ring = false,
  color,
  hasOther = true,
}) => {
  const getSize = useContext(SizeContext);
  const [option, setOption] = useState<any>({});

  useEffect(() => {
    setOption(
      getOption(getTop(data, hasOther), roseType, ring, color, getSize)
    );
  }, [data, hasOther, roseType, ring, color, getSize]);

  return (
    <ReactEcharts
      option={option}
      notMerge={true}
      style={{ width: "100%", height: "100%", position: "absolute" }}
    />
  );
};

export default RosePie;
